import { DepartmentDocument } from '../Department/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { CrewDocument, crewPullQueryBuilder } from './queryBuilder';

export function crewsFamilyMember(
  configBuilder: ConfigBuilder,
  department: FamilyMember<DepartmentDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<CrewDocument> {
  const syncConfig = configBuilder<CrewDocument>(RxdbCollectionNameV2.CREWS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, crewPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.CREWS, replicationState, [department, sites]);
}
